var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeekers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 48 48",
    height: 36,
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.924 42.006-.711-1.432c7.463-.987 13.374-6.898 14.36-14.361l1.433.711c-1.246 7.731-7.35 13.836-15.082 15.082Zm15.082-20.93-1.432.711c-.987-7.463-6.898-13.374-14.361-14.36l.711-1.433c7.731 1.246 13.836 7.35 15.082 15.082ZM21.787 40.574l-.711 1.432C13.345 40.76 7.24 34.656 5.994 26.924l1.432-.711c.987 7.463 6.897 13.374 14.361 14.36ZM7.427 21.787l-1.433-.711C7.24 13.345 13.344 7.24 21.076 5.994l.711 1.432c-7.463.987-13.374 6.897-14.36 14.361Zm1.618 1.049c.564-7.356 6.435-13.227 13.79-13.791L24 10.5l1.164-1.455c7.356.564 13.227 6.435 13.791 13.79L37.5 24l1.456 1.164c-.565 7.356-6.436 13.227-13.792 13.791L24 37.5l-1.164 1.456C15.48 38.39 9.609 32.52 9.045 25.163L10.5 24l-1.455-1.164ZM24 12a6 6 0 0 1 6 6 6 6 0 0 0-6 6 6 6 0 0 0-6-6 6 6 0 0 1 6-6Zm-6 18a6 6 0 0 1 0-12 6 6 0 0 0 6 6 6 6 0 0 0-6 6Zm12 0a6 6 0 0 0 0-12 6 6 0 0 1-6 6 6 6 0 0 1-6 6 6 6 0 0 0 12 0Zm0 0a6 6 0 0 0-6-6 6 6 0 0 0 6 6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekers);
export default __webpack_public_path__ + "static/media/seekers.420a4f33.svg";
export { ForwardRef as ReactComponent };